export const DEFAULT_PER_PAGE_APPOINTMENTS = 10

export const GET_APPOINTMENTS = 'admin/get_appointments'
export const GET_APPOINTMENT_BY_ID = 'admin/get_appointment_by_id'
export const GET_EXPORTED_TABLE = 'admin/get_exported_table'
export const DELETE_APPOINTMENT = 'admin/delete_appointment'
export const PAYMENT_REFUND = 'admin/payment_refund'
